import { SET_PERMISSION, SET_PERMISSIONS } from "../../constants/permissionConstants";

export const setPermission = (permission) => {
  return {
    type: SET_PERMISSION,
    permission,
  };
};

export const setPermissions = (permissions, filtered = false) => {
  return {
    type: SET_PERMISSIONS,
    permissions,
    filtered,
  };
};
